import { formatDate, getTextInCapitalize } from "./helperFunctions";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";

export const ACCESS_REQUEST_COLUMNS = [
  {
    uid: "name",
    name: "Name",
    sortable: true,
    align: "left",
    width: "180px",
  },
  {
    uid: "email",
    name: "Email",
    sortable: true,
    align: "left",
    width: "200px",
  },
  {
    uid: "organization_name",
    name: "Organization",
    sortable: true,
    align: "left",
    width: "150px",
  },
  {
    uid: "request_date",
    name: "Requested At",
    sortable: true,
    align: "left",
    width: "150px",
  },
  {
    uid: "role",
    name: "Role",
    sortable: true,
    align: "left",
    width: "100px",
  },
  {
    uid: "actions",
    name: "Actions",
    sortable: false,
    align: "center",
    width: "180px",
  },
];

export const createAccessRequestRenderCell = (
  onReview,
  isPending,
  allowReviewActions = true,
) => {
  return (user, columnKey) => {
    switch (columnKey) {
      case "name":
        return (
          <span className="text-gray-800 font-medium">
            {getTextInCapitalize(user?.name)}
          </span>
        );
      case "email":
        return <span className="text-gray-600 text-wrap break-all">{user?.email}</span>;
      case "organization_name":
        return (
          <span className="text-gray-600">
            {user?.organization_name
              ? getTextInCapitalize(user.organization_name)
              : "—"}
          </span>
        );
      case "request_date":
        return (
          <span className="text-gray-600 text-sm">
            {user?.request_date ? formatDate(user.request_date) : "—"}
          </span>
        );
      case "role":
        return (
          <span className="text-gray-600">
            {user?.role === "org_admin"
              ? "Org Admin"
              : user?.role === "user"
                ? "User"
                : "Super Admin"}
          </span>
        );
      case "actions": {
        const showActions =
          allowReviewActions &&
          user?.plan === null &&
          user?.trial_approved_at === null;

        const showText =
          user?.plan === "reject"
            ? "Rejected"
            : user?.trial_approved_at
              ? "Approved"
              : "";

        if (showActions) {
          return (
            <div className="flex items-center justify-center gap-2">
              <PrimaryButton
                onClick={() => onReview(user?.id, "approve")}
                disabled={isPending}
                isLoading={isPending}
                startContent={false}
                className="text-success-500 bg-success-50 hover:bg-success-500 hover:text-white transition-all duration-300"
              >
                Approve
              </PrimaryButton>

              <PrimaryButton
                onClick={() => onReview(user?.id, "reject")}
                startContent={false}
                className="text-error-500 bg-error-50 hover:bg-error-500 hover:text-white transition-all duration-300"
                disabled={isPending}
                isLoading={isPending}
              >
                Reject
              </PrimaryButton>
            </div>
          );
        }

        if (showText) {
          return (
            <span className="text-gray-800 font-medium">
              {showText}
            </span>
          );
        }

        return null;
      }
      default:
        return <span className="text-gray-600">{user[columnKey]}</span>;
    }
  };
};
